/**
 * Full-screen confetti for L7 成交 celebration.
 * 60 paper pieces fall from the top, each randomly colored, sized, delayed,
 * and given an x-drift. The whole thing auto-removes after ~4s.
 * Animation is pure CSS (@keyframes confettiFall in global.css).
 */
const COLORS = ['#3370ff', '#34c759', '#ff9500', '#ffba36', '#7c4dff', '#ee5253', '#5eb6e0', '#76b639'];

export function fireConfetti(pieces = 60) {
  const container = document.createElement('div');
  container.className = 'confetti-container';

  for (let i = 0; i < pieces; i++) {
    const piece = document.createElement('div');
    piece.className = 'confetti';
    piece.style.left = `${Math.random() * 100}%`;
    piece.style.background = COLORS[Math.floor(Math.random() * COLORS.length)];
    piece.style.setProperty('--dx', `${Math.random() * 200 - 100}px`);
    piece.style.animationDelay = `${Math.random() * 0.6}s`;
    piece.style.animationDuration = `${2.4 + Math.random() * 1}s`;
    piece.style.width = `${5 + Math.random() * 8}px`;
    piece.style.height = `${8 + Math.random() * 10}px`;
    container.appendChild(piece);
  }

  document.body.appendChild(container);
  setTimeout(() => container.remove(), 4000);
}
